<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-img
          :src="require('@/assets/banner-finantare_alt.png')"
          class="mx-auto"
          contain
          max-height="150px"
        ></v-img>
      </v-col>
    </v-row>

    <v-layout row v-if="error">
      <v-flex xs12 sm6 offset-sm3>
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs16 sm6 offset-sm3>
        <v-card>
          <v-card-text>

              <v-form @submit.prevent>
                <v-text-field
                  prepend-icon="mdi-account-circle"
                  shaped
                  rounded
                  solo
                  dense
                  flat
                  outlined
                  single-line
                  id="email"
                  v-model="email"
                  name="email"
                  label="email"
                  type="email"
                  required
                />

                <v-text-field
                  v-if="show"
                  prepend-icon="mdi-lock-question"
                  shaped
                  rounded
                  solo
                  dense
                  flat
                  outlined
                  single-line
                  id="password"
                  v-model="password"
                  name="password"
                  label="Password"
                  type="password"
                  required
                />
              </v-form>
          </v-card-text>
          <v-card-actions>
            <div>
              <template v-if="show">
                V-ati uitat parola?
                <a @click="showRecover" class="ml-1 text-decoration-underline">
                  Resetati-o acum
                </a>
              </template>
              <template v-else>
                <a @click="show = !show" v-if="!show" class="text-decoration-underline">
                  Inapoi la autentificare
                </a>
              </template>
              <!-- <template v-if="show">
                <br>
                Nu aveti un cont?
                <router-link :to="{ name: 'Signup' }" class="ml-1">
                  Creati unul acum.
                </router-link>
              </template> -->
            </div>
            <v-spacer></v-spacer>
            <v-btn @click="onSignIn" :loading="loading" color="primary" v-if="show">
              Autentificare
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon color="white" light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>



            <v-btn color="primary" @click="recoverPass" v-if="!show">
              Trimite mail
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Signin",
  data() {
    return {
      email: null,
      password: null,
      show: true
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        switch (value.role) {
          case "aplicant": {
            this.$router.push("/Personal");
            break;
          }
          case "el presidente":
          case "evaluator": {
            this.$router.push("/Formeval");
            break;
          }
          case "admin": {
            this.$router.push("/Admin");
            break;
          }
        }
      }
    }
  },
  methods: {
    onSignIn() {
      this.$store.dispatch("signUserIn", {
        email: this.email,
        password: this.password
      });
    },
    showRecover() {
      this.show = false;
    },
    recoverPass() {
      this.$store.dispatch("forgotPassword", {
        email: this.email
      });
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    }
  }
};
</script>
